import useGallery from "./hooks/useGallery";

import GalleryMain from "./GalleryMain";
import GalleryThumbs from "./GalleryThumbs";
import GalleryModal from "./GalleryModal";

import "./gallery.css";


export default function ProductGallery({ images = [] }) {

    const gallery = useGallery(images);
  

    if (!images.length)
        return null;

    return (

        <div className="product-gallery">

            <GalleryMain gallery={gallery} />
            <GalleryModal gallery={gallery} />

            <GalleryThumbs

                images={gallery.images}

                selected={gallery.selected}

                onSelect={gallery.selectImage}
                onOpen={gallery.openModal}

            />

        </div>

    );

}